<template>
	<section class="vreviews">
		<div class="container vreviews__container">
			<div class="vreviews__header">
				<slot name="heading"></slot>
				<slot name="text"></slot>
			</div>
			<div class="vreviews__left">
				<div class="mt-24">
					<div class="vreviews__section" v-for="(item, index) in sections" :key="index">
						<h3 class="vreviews__section__title">
							{{ item }}
							<span class="vreviews__section__title__category mobile-only">
								{{ rating.text[item] }}
							</span>
						</h3>
						<ul class="vreviews__section__list" @click="(evt) => onClickHandle(evt, item)">
							<li v-for="block in rateBlocks" :key="block.rate" class="vreviews__section__list__item"
								:class="{
									vreviews__section__list__item__active:
										rating.sections[item] === block.rate,
								}" :data-value="block.rate" :data-text="block.text">
								<svg class="icon vreviews__section__icon" role="img">
									<use :xlink:href="block.emoji"></use>
								</svg>
								<span class="vreviews__section__text laptop-only">{{ block.text }}</span>
							</li>
						</ul>
						<input type="hidden" :value="rating.sections[item]" :name="rating.names[index]" />
					</div>
				</div>

				<hr class="vreviews__sepparator" />

				<slot name="reviews-textarea" :onChangeHandle="onChangeHandle"></slot>

				<hr class="vreviews__sepparator" />

				<button data-micromodal-trigger="vreviews__submit" class="button button--primary laptop-only"
					type="button"  :disabled="!avgScore">
					<slot name="reviews-button"></slot>
				</button>

			</div>

			<slot name="clinic-information"></slot>
			<div class="vreviews__preview">
				<div class="vreviews__preview__header">
					<svg class="icon vreviews__preview__header__icon t-20 mr-8" role="img">
						<use xlink:href="#icon-info"></use>
					</svg>
					<slot name="reviews-preview-header-text"></slot>

				</div>
				<div class="vreviews__preview__content">
					<div class="vreviews__preview__rating" :class="{ vreviews__preview__rating__full: avgScore }">
						<span v-if="avgScore">{{ avgScore }}</span>
						<span v-else>-</span>
					</div>
					<slot name="reviewer"></slot>
					<p class="vreviews__preview__optional" v-if="rating['review']">
						{{ rating['review'] }}
					</p>
				</div>
			</div>

			<hr class="vreviews__sepparator mobile-only" />

			<button data-micromodal-trigger="vreviews__submit"
				class="button button--primary vreviews__submit--mobile mobile-only" type="button" :disabled="!avgScore">
				<slot name="reviews-button"></slot>
			</button>
		</div>
	</section>
</template>

<script setup>
import { ref, reactive, computed, watch } from 'vue';

const props = defineProps(['sections', 'rates']);

const rating = reactive({
	sections: {},
	review: '',
	text: {},
	names: [
		'friendliness_rating',
        'cleanliness_rating',
		'facilities_rating',
        'overall_experience_rating'
    ]
});

const sections = props.sections;
const rateBlocks = props.rates;

const onClickHandle = (event, name) => {
	if (!event.target.dataset.value) return;
	rating.sections[name] = +event.target.dataset.value;
	rating.text[name] = event.target.dataset.text;
};

// For optional text review
const onChangeHandle = (event) => {
	if (!event.target.value.length) rating['review'] = '';
	rating['review'] = event.target.value;
};

const avgScore = computed({
	get() {
		let sum = 0;
		for (let key in rating.sections) {
			sum += rating.sections[key];
		}

		if (Object.keys(rating.sections).length === sections.length) {
			return +(sum / sections.length).toFixed(1);
		} else return false;
	},
});

console.log("avgScore");
console.log(avgScore.value);
</script>
